var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 216 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h216v95H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#32C832",
    d: "M117.11 95a3.2 3.2 0 0 1 0-6.41h12.68a3.2 3.2 0 0 1 0 6.41h-12.68zm-7.66-17.14v5.89c0 3.1-1.26 5.9-3.3 7.95a11.21 11.21 0 0 1-7.94 3.3H86.5a3.2 3.2 0 0 1 0-6.41h11.7c1.32 0 2.53-.55 3.4-1.43a4.81 4.81 0 0 0 1.43-3.41v-5.89h-21a25.63 25.63 0 0 1-18.18-7.56 25.68 25.68 0 0 1-7.56-18.18V25.74c0-7.08 2.9-13.52 7.56-18.18A25.66 25.66 0 0 1 82.04 0h52.22c7.09 0 13.52 2.9 18.18 7.56A25.68 25.68 0 0 1 160 25.74v26.38c0 7.08-2.9 13.52-7.56 18.18a25.65 25.65 0 0 1-18.18 7.56h-24.8zm38.46-65.77a19.26 19.26 0 0 0-13.65-5.68H82.04a19.42 19.42 0 0 0-18.47 13.66l44.58 24.2 44.58-24.2a19.42 19.42 0 0 0-4.82-7.98zm5.68 40.03V26.9l-24.02 13.04 24.01 12.78.01-.6zm-5.68 13.65a19.5 19.5 0 0 0 4.31-6.54L122.84 43.6l-13.16 7.14c-1 .54-2.16.5-3.1-.02l-13.22-7.18-29.32 15.61a19.5 19.5 0 0 0 18 12.31h52.22c5.31 0 10.14-2.17 13.65-5.68zm-85.2-13.65v.5l23.92-12.74L62.71 26.9v25.22zM7.6 31.33a3.2 3.2 0 0 1 0-6.41h32.85a3.2 3.2 0 0 1 0 6.41H7.6zm9.6 13.23a3.2 3.2 0 0 1 0-6.42h12.67a3.2 3.2 0 1 1 0 6.42H17.2zm7.51 11.06a3.2 3.2 0 0 1 0-6.42h21.03a3.2 3.2 0 0 1 0 6.42H24.7zM3.21 44.56a3.2 3.2 0 0 1 0-6.42h3.17a3.2 3.2 0 0 1 0 6.42H3.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEmail);
export default __webpack_public_path__ + "static/media/send-email.99344d026d7eba103d7da475940f8202.svg";
export { ForwardRef as ReactComponent };